import { gql } from "@apollo/client";
import { REMITTANCE_ITEM_FRAGMENT } from "./remittanceItemFragment";

const GET_REMITTANCE_ITEM = gql`
  ${REMITTANCE_ITEM_FRAGMENT}
  query RemittanceItems($params: GetRemittanceParams!) {
    remittanceItems(params: $params) {
      total
      summary
      columns {
        key
        title
      }
      page
      limit
      items {
        ...RemittanceItemFields
      }
    }
  }
`;

export default GET_REMITTANCE_ITEM;
